
import { StrategyBaseClass } from './strategy-base-class.js'


export class BusinessChatService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 13;
  }
  getTypeString() {
    return 'business-chat';
  }
  getAllTasksTypes() {
    return [36];
  }
  getPrivateTaskTypes() {
    return [36];
  }

  canHaveSurveys() {
    return true;
  }

  getQuickRepliesElementsConfig() {
    return {
      maxAnswerNb: 20,
      answerLabelMaxLength: 40,
      questionBox: {
        minAnswers: 2,
        maxAnswers: 5,
      },
      hasDescription: false,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: false, // disabled for now, as question boxes are converted to list pickers for bzc
        hasImageControl: false
      },
      sendTextAfterButtonChoice: true,
      canSendVideo: true
    };
  }
  getTaskTypeString(taskType) {
    let mapping = {
      36: 'business-chat/msg'
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    let mapping = {
      36: 'business-chat-msg'
    };
    return mapping[taskType];
  }

  getEditorConfiguration(isPrivate) {
    return {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*',
      'videoEnabled': true,
      'bzcRichLinkEnabled': true,
      'fileEnabled': true
    };
  }

  static BusinessChatFactory($translate) {
    return new BusinessChatService($translate);
  }
}
BusinessChatService.BusinessChatFactory.$inject = ['$translate'];
